import { useFormContext } from 'react-hook-form';

import { DocumentController } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';
import type { TFileAttached } from '@/types/financing';

import { type FormType, fileDict } from '../../features/euras-bank-v2';

const HIDE_STATUSES = [
  'financed',
  'financed_pledge_missing',
  'financed_waiting_for_modification_before_pledge'
];

interface IProps {
  pledgeAgreementTemplate?: TFileAttached;
  pledgeRegistrationTemplate?: TFileAttached;
  pledgeAgreementSigned?: TFileAttached;
  pledgeRegistrationSigned?: TFileAttached;
}

// NOTICE: Не используется (01.10.2025). Возможно можно удалить
const EurasPledgeDocuments: React.FC<IProps> = ({
  pledgeAgreementTemplate,
  pledgeRegistrationTemplate,
  pledgeAgreementSigned,
  pledgeRegistrationSigned
}) => {
  const { selectedBank } = useAppSelector((state) => state.financingStep);
  const { control } = useFormContext<FormType>();

  const shouldHideEditableFields = HIDE_STATUSES.includes(
    selectedBank?.status.code || ''
  );
  const pledgeAgreementClassName =
    pledgeAgreementSigned || shouldHideEditableFields
      ? 'financing-step__field'
      : 'financing-step__field--half';
  const pledgeRegistrationClassName =
    pledgeRegistrationSigned || shouldHideEditableFields
      ? 'financing-step__field'
      : 'financing-step__field--half';

  const onRework = selectedBank?.status.code === 'on_rework';

  return (
    <>
      {pledgeAgreementSigned && pledgeAgreementTemplate ? (
        <DocumentController
          fileLink={pledgeAgreementTemplate.uuid}
          title={fileDict.pledgeAgreementTemplate}
          downloadable
          visiable={!onRework}
        />
      ) : (
        pledgeAgreementTemplate && (
          <>
            <DocumentController
              fileLink={pledgeAgreementTemplate.uuid}
              title={fileDict.pledgeAgreementTemplate}
              downloadable
              wrapperClassName={pledgeAgreementClassName}
            />
            <DocumentController
              control={control}
              name="pledgeAgreementSigned"
              title={fileDict.pledgeAgreementSigned}
              uploadable
              isRequired
              visiable={!shouldHideEditableFields}
              wrapperClassName={pledgeAgreementClassName}
            />
          </>
        )
      )}

      {pledgeRegistrationSigned && pledgeRegistrationTemplate ? (
        <DocumentController
          title={fileDict.pledgeRegistrationTemplate}
          fileLink={pledgeRegistrationTemplate?.uuid || ''}
          visiable={!onRework}
          downloadable
        />
      ) : (
        pledgeRegistrationTemplate && (
          <>
            <DocumentController
              title={fileDict.pledgeRegistrationTemplate}
              fileLink={pledgeRegistrationTemplate?.uuid || ''}
              downloadable
              wrapperClassName={pledgeRegistrationClassName}
            />
            <DocumentController
              control={control}
              name="pledgeRegistrationSigned"
              title={fileDict.pledgeRegistrationSigned}
              uploadable
              isRequired
              visiable={!shouldHideEditableFields}
              wrapperClassName={pledgeRegistrationClassName}
            />
          </>
        )
      )}
    </>
  );
};

export default EurasPledgeDocuments;
